/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/prop-types */
import { Typography } from '@material-ui/core';
import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import StoryContext from '../../contexts/StoryContext';
import { composeWhereClause } from '../../modules/data';
import { rdsTabulate } from '../../modules/rds';
import { stateFIPS } from '../../modules/states';
import { toFormattedNumber } from '../../modules/text';
import BarChart from '../BarChart';
import NoDataVisual from '../NoDataVisual';
import { years } from '../../modules/years';

function TotalNumberOfProvidersSubsidies({ height = 300, width }) {
  const { stateCode } = useParams();
  const [ready, setReady] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState([]);
  const [noData, setNoData] = useState(false);
  const { primaryColor, secondaryColor } = useContext(StoryContext);

  function getLabel() {
    return 'Providers Accepting Subsidies';
  }

  useEffect(() => {
    setError(null);
    setReady(false);
    const getCapacity = function getCapacity() {
      let whereClause = `state_fips=${stateFIPS[stateCode.toUpperCase()]} AND is_subsidized=1`;
      // whereClause += ' AND (setting_type=HOM OR setting_type=CEN) AND license_type=LIC';
      whereClause += composeWhereClause({}, true, false); // don't use child age. Not avaiable in provider

      return rdsTabulate('ccdc', 'tract_licensed_capacity', {
        dims: 'wave_id',
        measure: 'capacity:SUM(cnt_provider)',
        where: whereClause,
        orderby: 'wave_id',
        format: 'amcharts',
      }, false, null); // use cache, unset wave
    };

    getCapacity().then((response) => {
      // console.log(response.parsedBody.dataProvider);
      const dataItems = response.parsedBody.dataProvider;
      if (dataItems.length === 0) {
        setNoData(true);
        return;
      }
      let dataObject = { label: getLabel() };
      dataItems.forEach((di) => {
        const label = di.wave_id === years.rdsCovidWave.toString() ? 'Pre-Pandemic' : 'Mid-Pandemic';
        const v = {};
        v[label] = di.capacity;
        dataObject = { ...dataObject, ...v };
      });
      setData([dataObject]);
    })
      .catch((e) => {
        setError(e);
      })
      .finally(() => {
        setReady(true);
      });
  }, [stateCode]);

  const keys = ['Pre-Pandemic', 'Mid-Pandemic'];
  const groupKey = 'label';

  const title = `Total Number of ${getLabel()}`;

  const formatterFunction = function formatterFunction(payload) {
    const tooltipLabels = {
      'Pre-Pandemic': years.covidFromMonthYear,
      'Mid-Pandemic': years.covidToMonthYear,
    };

    if (payload.value) {
      return `${tooltipLabels[payload.dataKey]}: <b>${toFormattedNumber(payload.value)}</b> providers accepting subsidies.`;
    }
    return 'Insufficient sample size';
  };

  if (noData) {
    return <NoDataVisual />;
  }

  return (
    <>
      {error && <Typography variant="body1" color="error">{error.message}</Typography>}
      <BarChart
        valueFormatter={toFormattedNumber}
        formatterFunction={formatterFunction}
        height={height}
        width={width}
        ready={ready}
        data={data}
        keys={keys}
        groupKey={groupKey}
        title={title}
        colors={[primaryColor, secondaryColor]}
      />
    </>
  );
}

export default TotalNumberOfProvidersSubsidies;
